import React, {useState} from "react";
import {HashLink as Link} from 'react-router-hash-link';
import Panel from "../../Panel";
import Modal from "../../Modal";
import { CgMoreVerticalO } from "react-icons/cg";

const Ogen = () => {
    const [show, setShow] = useState({});

    const toggle = (index) => {
        let state = {...show}
        state[index] = !(state[index] ?? false);
        setShow(state);
    };

    const Title = ({index, title}) => (
        <h4 onClick={() => toggle(index)} style={{cursor: "pointer"}}>
            <div style={{marginRight: '5px'}}>{title}</div>
            <div><CgMoreVerticalO /></div>
        </h4>
    )

    return (
        <Modal title={'HOE KAN JE SIGNALEN HERKENNEN?'}
               image={'https://care-free.app/wp-content/uploads/2024/01/Hoowy_Ogen_RolloverActive.png'}>
            <div>
                <p>
                    In <b>stap 1 van de meldcode</b> ga je <b>signalen in kaart brengen.</b> Dit onderdeel kan je helpen om stap 1 van de meldcode te doorlopen.
                </p>

                <h2>RISICO- EN BESCHERMENDE FACTOREN</h2>

                <h3>RISICOFACTOREN</h3>

                <p>
                    <b>Kindermishandeling is het gevolg van een combinatie van uiteenlopende risicofactoren.</b> Risicofactoren zijn <b>gedragingen, omstandigheden of kenmerken</b> die de <b>kans dat kindermishandeling zich voordoet vergroten</b>. Dit betekent niet dat wanneer er risicofactoren aanwezig zijn er ook altijd sprake is van kindermishandeling.  Als er <b>beschermende factoren</b> zijn kan er voldoende <b>balans</b> zijn om kindermishandeling <b>te voorkomen</b>. Hieronder vind je meer informatie over de risicofactoren bij kindermishandeling.
                </p>

                <Title index={'111'} title={'PROBLEMEN EN PERSOONLIJKHEID VAN DE OUDER'}/>

                {show['111'] && <p>
                    Ouders willen het graag goed doen, er kan een reden zijn dat dit (tijdelijk) niet lukt. <b>Psychische of psychiatrische problemen, gebrekkige opvoedingsvaardigheden</b>, het hebben van een <b>Licht Verstandelijke Beperking (LVB)</b> en <b>stress</b> zijn risicofactoren die de kans op kindermishandeling kunnen vergroten. Daarnaast is de kans ook groter bij ouders <b>die als kind zelf mishandeld zijn en/of andere negatieve jeugdervaringen</b> hebben meegemaakt.
                </p>}


                <Title index={'112'} title={'KINDEREN MET EXTRA ZORG'}/>

                {show['112'] && <p>
                    Als gevolg van <b>vroeggeboorte</b> of een <b>lichamelijke of verstandelijk beperking</b> kan het zo zijn dat kinderen speciale aandacht nodig hebben van hun ouders. Dit vraagt van ouders meer geduld, extra zorg en meer aandacht.  Wanneer kinderen <b>gedragsproblemen</b> hebben vraagt dit om voldoende opvoedingskwaliteiten en inspanningen van ouders om met dit gedrag om te kunnen gaan. Deze zorg kan voor ouders stress en gevoelens van incompetentie als gevolg hebben.
                </p>}

                <Title index={'113'} title={'LEEFOMSTANDIGHEDEN'}/>

                {show['113'] && <p>
                    Wanneer een gezin woont in een buurt met <b>zwakke sociale verbanden, criminaliteit, drugsproblematiek, armoede en achterstand</b> kan dit de kans op kindermishandeling vergroten. Ook bij gezinssamenstellingen zoals, eenoudergezinnen, stiefgezin en/of grote gezinnen met meer dan vier kinderen is de kans op kindermishandeling mogelijk groter. Daarnaast kan kindermishandeling meer voorkomen wanneer het gezin leeft in een samenleving waarin geweld meer getolereerd wordt.
                </p>}

                <Title index={'114'} title={'SPECIFIEK VOOR SEKSUEEL MISBRUIK'}/>

                {show['114'] &&
                    <div>
                        <p>
                            <u>Persoonlijke risicofactoren</u><br />
                            Een <b>verstandelijke beperking, chronische ziekte</b> of <b>ontwikkelingsachterstand</b> bij een kind kan het risico op seksueel misbruik vergroten. <b>LHBTQIA+ kinderen</b> kunnen te maken krijgen met minderheidsstress, isolatie en discriminatie. Hierdoor kunnen zij kwetsbaarder zijn voor seksueel misbruik. Als een kind <b>al eerder slachtoffer</b> is geworden van seksueel misbruik bij <b>henzelf of iemand in hun omgeving</b> (broers of zussen) kan de kans op seksueel misbruik toenemen.
                        </p>

                        <p>
                            <u>Risicofactoren in de ouder-kindrelatie en de houding van ouders</u><br />
                            Wanneer <b>de moeder in het gezin</b> door een verslaving, psychiatrische problemen of een verstandelijk beperking <b>fysiek en emotioneel niet voldoende beschikbaar kan zijn</b> is er een vergrote kans op seksueel misbruik. <b>Overmatige bescherming</b> van het kind, <b>huiselijk geweld</b>, een <b>lagere sociale economische status van ouders, verstoorde interactiepatronen, verstoorde gezinsrelaties</b>, maar ook het <b>ontbreken van een ondersteunende relatie tussen ouder en kind</b> en een <b>tekort aan opvoedingsvaardigheden</b> kunnen risicofactoren vormen.
                        </p>

                        <p>
                            <u>Risicofactoren in de verdere omgeving:</u><br />
                            Als een gezin <b>een beperkt sociaal netwerk</b> heeft, <b>in isolatie leeft</b>, woont in <b>een stedelijk gebied</b> of woont in <b>een omgeving met veel geweld</b> kan dit de kans op seksueel misbruik vergroten.
                        </p>
                    </div>}

                <h3>BESCHERMENDE FACTOREN</h3>

                <p>
                    <b>Beschermende factoren</b> kunnen een <b>positieve kracht</b> zijn in risicovolle situaties, en kunnen helpen <b>om kindermishandeling te voorkomen</b>. De beschermende factoren kunnen we vinden <b>bij kinderen zelf, bij hun opvoeders en in de omgeving</b> en geven zowel de ouder als het kind <b>veerkracht</b> ondanks de mogelijke negatieve omstandigheden. Hieronder vind je meer informatie over de beschermende factoren bij kindermishandeling:
                </p>

                <Title index={'121'} title={'BIJ DE OPVOEDER'}/>

                {show['121'] && <p>
                    Ouders die voldoende <b>kennis hebben over opvoeding en ontwikkeling</b> hebben, <b>een harmonieuze relatie hebben</b> met hun partner, zich bewust zijn <b>van eigen jeugdervaringen</b> en <b>de invloed daarvan op hun eigen handelen</b> kunnen dit als beschermende factoren gebruiken. Ook <b>praktische en emotionele steun</b> vanuit hun netwerk, <b>een veilige hechting, warmte en affectie van de ouder</b> en de <b>bereidheid om hulp te accepteren</b> wanneer dit nodig is, zijn beschermde factoren.
                </p>}


                <Title index={'122'} title={'BIJ HET KIND'}/>

                {show['122'] && <p>
                    Wanneer het kind <b>zelfwaarding, zelfvertrouwen, goede interpersoonlijke vaardigheden</b>, een <b>bovengemiddelde intelligentie</b> en een <b>makkelijk temperament</b> heeft zijn dit beschermende factoren voor het kind. Ook <b>het besef</b> en <b>het vertrouwen in de eigen capaciteit</b> dat je zelf iets kan bijdragen aan het <b>voorkómen en oplossen van problemen</b> is een beschermende factor.
                </p>}

                <Title index={'123'} title={'IN DE OMGEVING'}/>

                {show['123'] && <p>
                    In de omgeving van het kind zijn het hebben van <b>positieve relaties met leeftijdsgenoten, positieve onderlinge relaties in het gezin</b> en <b>binding met de gemeenschap en school</b> beschermende factoren. Daarbij is het hebben van <b>een praktisch en emotioneel steunend sociaal netwerk</b> voor de ouders en het kind ook een beschermende factor.
                </p>}

                <Title index={'124'} title={'SPECIFIEK BIJ SEKSUEEL MISBRUIK'}/>

                {show['124'] && <p>
                    Over beschermende factoren bij seksueel misbruik is nog weinig bekend, maar enkele factoren lijken een gunstig effect te hebben op de gevolgen van seksueel misbruik.<br/>
                    Het hebben van <b>eigenwaarde, sociale vaardigheden, steun van de niet-misbruikende ouder</b> of <b>andere belangrijke volwassenen</b> zijn beschermende factoren. Wanneer een kind zich <b>gesteund voelt</b> en <b>opgroeit in een gezinsklimaat met sterke onderlinge betrokkenheid, een positief probleemoplossend vermogen, flexibiliteit en een duidelijke organisatie</b>, laat minder symptomen zien en herstelt sneller van het seksueel misbruik.
                </p>}

                <h2>SIGNALEN KINDERMISHANDELING</h2>

                <p>
                    <b>Een signaal is een actueel teken of kenmerk bij een kind dat aangeeft dat er iets aan de hand is</b>. De <b>verklaring</b> voor zo’n signaal <b>kan kindermishandeling zijn</b>, maar er kan ook <b>een andere oorzaak zijn</b>. De <b>signalenlijsten</b> hieronder zijn een <b>hulpmiddel</b> om een <b>vermoeden van kindermishandeling te onderbouwen. Je hoeft het niet te bewijzen</b>.
                </p>

                <p>
                    <b>Download hieronder de signalenlijsten per leeftijdscategorie:</b>

                    <ul>
                        <li><a className={'download'} href={"https://care-free.app/wp-content/uploads/2024/01/16.-Signalenlijst-0-4-jaar.pdf"} target={"_blank"}>Signalenlijst 0-4 jaar</a></li>
                        <li><a className={'download'} href={"https://care-free.app/wp-content/uploads/2024/01/17.-Signalenlijst-4-12-jaar.pdf"} target={"_blank"}>Signalenlijst 4-12 jaar</a></li>
                        <li><a className={'download'} href={"https://care-free.app/wp-content/uploads/2024/01/18.-Signalenlijst-12-18-jaar.pdf"} target={"_blank"}>Signalenlijst 12-18 jaar</a></li>
                    </ul>
                </p>
            </div>
        </Modal>
    );
}


export default Ogen;
